import { render, staticRenderFns } from "./beheer-op-afstand.vue?vue&type=template&id=7a330960&scoped=true"
import script from "./beheer-op-afstand.vue?vue&type=script&lang=js"
export * from "./beheer-op-afstand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a330960",
  null
  
)

export default component.exports